import React, { FC, useContext } from 'react';
import { Box, Icon, useMediaQuery, Theme, belowBreakpoint, IconSize } from '@bechtel/gds';
import {
  StatBlockPriorityCountStyled,
  StatBlockPriorityIconStyled,
  StatBlockPriorityInnerStyled,
  StatBlockPriorityTextStyled,
  StatBlockPriorityStyled,
  StatBlockRowStyled,
  StatBlockValueStyled,
} from './styled';
import { PriorityStatBlockProps } from './types';
import { css, ThemeContext } from 'styled-components';
import { StatsSpinner } from '@bechtel/client-common';

export const PriorityStatBlock: FC<PriorityStatBlockProps> = ({
  label,
  value,
  priorityCount,
  onStatClick,
  onPriorityStatClick,
  loading,
  ...rest
}) => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  return (
    <StatBlockRowStyled data-testid="priority-stat-block" {...rest}>
      <Box
        style={{ cursor: Number(value) > 0 ? `pointer` : `default` }}
        px={{ sm: '450' }}
        pb={{ sm: '500' }}
        mt={{ sm: '400' }}
        alignItems={{ sm: 'baseline' }}
        justifyContent={{ sm: 'space-between' }}
        onClick={() => {
          if (Number(value) === 0 || !onStatClick) return;
          onStatClick();
        }}
      >
        <Box pr={{ sm: '450' }}>
          <StatBlockValueStyled data-testid="priority-stat-block-value">
            {!loading ? value : <StatsSpinner />}
          </StatBlockValueStyled>
        </Box>
        <Box
          data-testid="priority-stat-block-label"
          css={`
            ${({ theme }) =>
              css`
                bottom: ${theme.spacings[300]};
                font-size: ${theme.spacings[450]};
                color: ${theme.colors.grey[700]};
                position: relative;
              `}
          `}
        >
          {label}
        </Box>
      </Box>

      <StatBlockPriorityStyled
        style={{ cursor: Number(priorityCount) > 0 ? `pointer` : `default` }}
        onClick={() => {
          if (Number(priorityCount) === 0 || !onPriorityStatClick) return;
          onPriorityStatClick();
        }}
      >
        <StatBlockPriorityInnerStyled>
          <StatBlockPriorityCountStyled> {!loading ? priorityCount : <StatsSpinner />}</StatBlockPriorityCountStyled>
          <Box pl={{ sm: '600' }}>
            <StatBlockPriorityIconStyled>
              <Icon
                data-testid="priority-stat-block-icon"
                icon="flame"
                size={isWideScreen ? IconSize.SMALL : IconSize.MEDIUM}
                fillColor="white"
              />
            </StatBlockPriorityIconStyled>
            <StatBlockPriorityTextStyled>Priority Welds</StatBlockPriorityTextStyled>
          </Box>
        </StatBlockPriorityInnerStyled>
      </StatBlockPriorityStyled>
    </StatBlockRowStyled>
  );
};
